<template>
  <div>
    <section class="container">
      <div class="sub_contents_wrap">
        <seach-box
          v-bind:adSearchStatus="adSearchStatus"
          v-bind:searchWord="form.searchWord"
          v-bind:dataType="form.dataType"
          v-bind:totalSearch="totalSearch"
          @updateStatus="updateAdSearchStatus"
          @clickSearch="updateSubmit"
        >
        </seach-box>
        <div class="fillter_p_wrap">
          <div class="result_top_box">
            <p class="r_t_text">
              Search Results for: <strong>"{{ searchWordDisp }}"</strong>
            </p>
            <div class="r_t_right">
              <div class="btn-group">
                <a
                  class="btn btn-outline-secondary btn-lg toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownSort"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ dispSortField }}
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownSort">
                  <li v-for="item of sortFields" v-bind:key="item.value">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="updateSortField(item.value, item.displayVal)"
                      >{{ item.displayVal }}</a
                    >
                  </li>
                </ul>
              </div>
              <div class="btn-group">
                <a
                  class="btn btn-outline-secondary btn-lg toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownOrder"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ dispOrder }}
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownOrder">
                  <li v-for="item of sortOrders" v-bind:key="item.value">
                    <a
                      class="dropdown-item"
                      href="#"
                      @click="updateSortOrder(item.value, item.displayVal)"
                      >{{ item.displayVal }}</a
                    >
                  </li>
                </ul>
              </div>
              <button class="btn btn-primary btn-lg" @click="fetchData">Confirm</button>
            </div>
          </div>
          <div class="wrap_con">
            <div class="left_con">
              <div class="fillter_left_box">
                <h4>
                  <span>{{ $t("product.filter") }}</span
                  ><a href="#" class="l_fillter_bt" @click="changeShowFilter()"
                    ><em>Fillter</em></a
                  >
                </h4>
                <div class="fillter_inner">
                  <div class="fillter_group_box f_g_active">
                    <p>
                      <a href="#">{{ $t("product.product") }}</a>
                    </p>
                    <ul v-if="productFacet">
                      <li v-for="(item, index) in productFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.paramProductList"
                            @change="changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                        <ul v-if="item.children">
                          <li v-for="(citem, cindex) in item.children" :key="cindex">
                            <label class="facet_chk_text"
                              ><input
                                type="checkbox"
                                class="facet_chk"
                                :value="citem.id"
                                v-model="form.paramProductList"
                                @change="changeFilter()"
                              />{{ citem.name }} ({{ citem.count }})</label
                            >
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div class="fillter_group_box f_g_active">
                    <p>
                      <a href="#">{{ $t("product.documentType") }}</a>
                    </p>
                    <ul v-if="doctypeFacet">
                      <li v-for="(item, index) in doctypeFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.docType"
                            @change="changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                      </li>
                    </ul>
                  </div>

                  <div class="fillter_group_box f_g_active">
                    <p>
                      <a href="#">{{ $t("product.cerfication") }}</a>
                    </p>
                    <ul v-if="exhaustFacet">
                      <li v-for="(item, index) in exhaustFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.paramExhaustCertiList"
                            @change="changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="middle_con">
              <div class="f_w_box">
                <!-- PDF -->
                <div class="product_list_wrap">
                  <div class="s_r_group_box" v-if="this.pdfResultShow">
                    <h5 class="result_h5_title">
                      PDF({{ pdfGroup.numFound ? pdfGroup.numFound : 0 }})
                    </h5>
                    <a
                      href="javascript:void(0);"
                      @click="goSearchPdf"
                      class="common_btn_more"
                      >more</a
                    >
                    <ul>
                      <li v-for="(item, index) in pdfGroup.documentList" :key="index">
                        <p class="p_l_bt_box">
                          <a
                            v-if="item.authViewYn == 'Y' && item.pdf_node_ref"
                            :href="
                              '/document/preview?noCache=' +
                              date +
                              '&uid=' +
                              item.pdf_node_ref.replace('workspace://SpacesStore/', '')
                            "
                            target="_blank"
                            class="p_l_icon04"
                            title="PDF View"
                            >View</a
                          >
                          <a
                            v-if="item.authDownloadYn == 'Y' && item.pdf_node_ref"
                            @click="
                              pdfDownload(
                                item.pdf_node_ref.replace('workspace://SpacesStore/', '')
                              )
                            "
                            class="p_l_icon02"
                            title="PDF Download"
                            >PDF</a
                          >
                          <a
                            v-if="item.authYn == 'Y'"
                            href="#"
                            @click="showHistoryPopup(item.doc_id, item.title)"
                            class="p_l_icon03"
                            title="Version History"
                            >History</a
                          >
                        </p>
                        <a href="#" class="p_l_title">
                          {{ item.doc_title }}
                          <em v-if="item.part_no != null && item.part_no != ''">
                            | {{ item.modelcode.join(", ") }} |
                            {{ item.exhaust.join(", ") }} | {{ item.doctype_enm }} |
                            {{ item.model }} | {{ item.lang }} | {{ item.part_no }} |
                            {{ item.pubdate }}</em
                          >
                          <em v-else>
                            | {{ item.modelcode.join(", ") }} |
                            {{ item.exhaust.join(", ") }} | {{ item.doctype_enm }} |
                            {{ item.model }} | {{ item.lang }} | {{ item.pubdate }}</em
                          >
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- WebHelp -->
                  <div class="s_r_group_box" v-if="this.htmlResultShow">
                    <h5 class="result_h5_title">
                      Web Help({{ webhelpGroup.numFound ? webhelpGroup.numFound : 0 }})
                    </h5>
                    <a
                      href="javascript:void(0);"
                      @click="goSearchWebhelp"
                      class="common_btn_more"
                      >more</a
                    >
                    <ul>
                      <li v-for="(item, index) in webhelpGroup.documentList" :key="index">
                        <p class="p_l_bt_box">
                          <a
                            v-if="item.authWebhelpYn == 'Y' && item.ver_node_ref"
                            :href="
                              '/docview/model/lang/' +
                              item.ver_node_ref.replace('workspace://SpacesStore/', '') +
                              '/' +
                              item.filename
                            "
                            target="_blank"
                            class="p_l_icon01"
                            title="Web View"
                            >WebHelp</a
                          >
                          <a
                            v-if="item.authYn == 'Y'"
                            href="#"
                            @click="showHistoryPopup(item.doc_id, item.title)"
                            class="p_l_icon03"
                            title="Version History"
                            >History</a
                          >
                        </p>
                        <a href="#" class="p_l_title">
                          {{ item.title }}
                          <em>
                            | {{ item.modelcode.join(", ") }} |
                            {{ item.exhaust.join(", ") }} | {{ item.doctype_enm }} |
                            {{ item.model }} | {{ item.lang }} | {{ item.pubdate }}</em
                          >
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- 데이터 없을때 -->
                  <div
                    class="search_no_data"
                    v-if="!this.pdfResultShow && !this.htmlResultShow"
                  >
                    <span>Your search did not match any documents.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--history 모달-->
      <HistoryModal
        id="historyModal"
        v-if="showModal"
        @close="showModal == false"
        :docId="form.docId"
        :docTitle="docTitle"
        ref="historyModal"
      >
        <template slot="footer">
          <button
            type="button"
            @click="closeModal"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            {{ $t("common.close") }}
          </button>
        </template>
      </HistoryModal>
    </section>
    <advanced-search
      v-bind:adSearchStatus="adSearchStatus"
      v-bind:totalSearch="totalSearch"
      @update="updateAdSearchStatus"
      @clickSearch="submitAdvancedSearch"
    >
    </advanced-search>
  </div>
</template>

<script>
import router from "@/routes/index";
import { getSearchIndex } from "@/api/search";
import AdvancedSearch from "@/components/search/AdvancedSearch.vue";
import SeachBox from "@/components/search/SearchBox.vue";
import { preDownload } from "@/api/document";

import HistoryModal from "@/components/modal/HistoryModal";
import $ from "jquery";

export default {
  components: {
    AdvancedSearch,
    SeachBox,
    HistoryModal,
  },
  data() {
    return {
      adSearchStatus: false,
      result: {},
      pagingVO: "",
      productFacet: [],
      doctypeFacet: [],
      exhaustFacet: [],
      modelcodeFacet: [],
      pdfGroup: [],
      webhelpGroup: [],
      documentList: [],
      searchWordDisp: "",
      pdfResultShow: true,
      htmlResultShow: true,
      dispSortField: "Sort Field",
      dispOrder: "Order",
      totalSearch: true,
      form: {
        searchWord: "",
        page: 1,
        paramProductList: [],
        paramExhaustCertiList: [],
        docType: [],
        pubType: [],
        pubdate1: "",
        pubdate2: "",
        allVer: false,
        dataType: "all",
        withinSearch: false,
        preQuery: "",
        sortField: null,
        sortOrder: null,
        docId: "",
      },
      sortFields: [
        { value: "relevance", displayVal: "Relevance" },
        { value: "title", displayVal: "Title" },
        { value: "pubdate", displayVal: "Published Date" },
      ],
      sortOrders: [
        { value: "desc", displayVal: "DESC" },
        { value: "asc", displayVal: "ASC" },
      ],
      showModal: false,
      docTitle: "",
      date: new Date().toISOString(),
    };
  },

  methods: {
    async fetchData() {
      try {
        let loader = this.$loading.show({});

        const response = await getSearchIndex(this.form);
        this.result = response.data.result;
        console.info(response.data.exhaustFacet);
        this.productFacet = response.data.productFacet;
        this.doctypeFacet = response.data.doctypeFacet;
        this.exhaustFacet = response.data.exhaustFacet;
        this.modelcodeFacet = response.data.modelcodeFacet;
        this.form.preQuery = response.data.query;

        this.pdfGroup = response.data.pdfGroup;
        this.webhelpGroup = response.data.webhelpGroup;

        this.pdfResultShow = this.pdfGroup.documentList.length != 0;
        this.htmlResultShot = this.webhelpGroup.documentList.length != 0;
        this.searchWordDisp = this.form.searchWord;

        loader.hide();
      } catch (error) {
        console.log(error);
      }
    },
    changeFilter() {
      this.fetchData(1);
    },
    updateSubmit(form) {
      this.form.searchWord = form.searchWord;
      this.form.dataType = form.dataType;
      this.form.pubType = []; // clean it if advanced search is executed.
      this.form.allVer = form.allVer;
      this.form.withinSearch = form.withinSearch;

      this.fetchData();
    },
    submitAdvancedSearch(payload) {
      // variables init
      this.form.paramProductList = [];
      this.form.docType = [];
      this.form.paramExhaustCertiList = [];

      this.form.searchWord = payload.searchWord;
      if (payload.prod_class) this.form.paramProductList.push(payload.prod_class);
      if (payload.prod_id) this.form.paramProductList.push(payload.prod_id);
      if (payload.certification)
        this.form.paramExhaustCertiList.push(payload.certification);

      this.form.docType = payload.doc_type;
      this.form.pubType = payload.pub_type; // equal to datatype
      this.form.pubdate1 = payload.pubdate1;
      this.form.pubdate2 = payload.pubdate2;

      this.fetchData();
    },
    //검색페이지
    clickSearch() {
      this.fetchData();
    },
    showHistoryPopup(docId, docTitle) {
      this.form.docId = docId;
      this.docTitle = docTitle;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.form.docId = "";
      this.docTitle = "";
    },
    goSearchPdf() {
      this.$router.push({ name: "pdf", params: this.form });
    },
    goSearchWebhelp() {
      this.$router.push({ name: "webhelp", params: this.form });
    },
    onChangeChild(prodId) {
      var checked = this.form.paramProductList.indexOf(prodId) > -1 ? true : false;
      for (var i = 0; i < this.productList.length; i++) {
        var currentProdId = this.productList[i].prodId;
        var children = this.productList[i].children;
        if (currentProdId == prodId && children != null) {
          for (var j = 0; j < children.length; j++) {
            if (checked) {
              this.form.paramProductList.push(children[j].prodId);
            } else {
              const idx = this.form.paramProductList.indexOf(children[j].prodId);
              if (idx > -1) this.form.paramProductList.splice(idx, 1);
            }
          }
        }
      }
    },
    updateAdSearchStatus(adSearch) {
      this.adSearchStatus = adSearch;
    },
    updateSortField(key, val) {
      this.form.sortField = key;
      this.dispSortField = val;

      this.updateSortOrder(this.sortOrders[0].value, this.sortOrders[0].displayVal);
    },
    updateSortOrder(key, val) {
      if (this.form.sortField == "relavance") {
        this.form.sortOrder = this.sortOrders[0].value;
        this.dispOrder = this.sortOrders[0].displayVal;
      } else {
        this.form.sortOrder = key;
        this.dispOrder = val;
      }
    },
    changeShowFilter() {
      $(".fillter_inner").toggle();
    },
    async pdfDownload(uid) {
      let loader = this.$loading.show({});

      const response = await preDownload(uid);
      if (response.data.status) {
        loader.hide();
        window.open("/document/download/pdf?uid=" + uid);
      } else {
        loader.hide();
        alert("Download failed");
      }
    },
  },
  created() {
    if (this.$session.get("token") == null) {
      router.push("/login");
    } else {
      this.$root.$emit("initMenuClassActive");
      if (this.$route.params.searchWord)
        this.form.searchWord = this.$route.params.searchWord;
      if (this.$route.params.page) this.form.page = this.$route.params.page;

      this.fetchData();
    }
  },
};
</script>

<style></style>
